module.exports = __webpack_public_path__ + "img/bg-pattern-ico.6279461d.png";